import React, { Component } from 'react';
import PropTypes from 'prop-types';
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import cx from "classnames";

class PhoneNumberInput extends Component {
    static propTypes = {
        id: PropTypes.string,
        input: PropTypes.object,
        meta: PropTypes.object,
        className: PropTypes.string
    };

    handleChange(value, country, event, number) {
        let formattedNumber = number;
        if(country.countryCode == 'fr' && value.length > country.dialCode.length){
            formattedNumber = number.replace('+'+country.dialCode, '')
            if(formattedNumber.trim()[0] == '0'){
                formattedNumber = formattedNumber.trim().substring(1);
            }
            formattedNumber = '+'+country.dialCode + formattedNumber;
            this.props.input.onChange(formattedNumber.replace(/\s/g, ""));
        }else {
            this.props.input.onChange('+' + value);
        }
    }

    render() {
        const {  input, placeholder, className, disabled = false, defaultCountry } = this.props;
        return (
            <PhoneInput
                disabled={disabled}
                inputClass={cx(
                    className,
                        {
                            "disabled:cursor-not-allowed disabled:bg-gray-50 disabled:text-gray-500 disabled:ring-gray-200": disabled
                        }
                )}
                value={input.value}
                country={defaultCountry? defaultCountry.value.toLowerCase() : "fr"}
                preferredCountries={['fr', 'es', 'de', 'gb']}
                onChange={::this.handleChange}
                placeholder={placeholder}
                onFocus={input.onFocus}
                onBlur={input.onBlur}
            />
        );
    }
}

export default PhoneNumberInput;
